module.exports = {"shareholder":"Shareholder of Corporation","director":"Director","officer":"Officer","limited_partner":"Limited Partner","general_partner":"General Partner","llc_member":"Member","llc_manager":"Manager","trustee":"Trustee","trustor":"Trustor","beneficiary":"Beneficiary","llc_owner":"Principal Owner of LLC","individual_proprietor":"Individual proprietor"}


//////////////////
// WEBPACK FOOTER
// ./src/components/entities/resources/partnership.json
// module id = V/8Z
// module chunks = 1